<template>
  <div class="base-decoration-line"></div>
</template>

<script>
export default {
  name: 'DecorationLine',
}
</script>

<style scoped lang="scss">
.base-decoration-line {
  // TODO: fix color after designer's changes on template
  border-bottom: 1px solid var(--bg-3);
}
</style>
